module.exports = __webpack_public_path__ + "static/media/Dafinite.8529d5fc.jpg";